import useApi, { ApiOptions } from '../base/useApi';
import ScanConsultantSummaryDTO from '@src/adapters/dto/scan/ScanConsultantSummaryDTO';

interface Params {
  pageSize: number;
  currentPage: number;
  hospitalId?: string;
}

interface Result {
  scans: ScanConsultantSummaryDTO[];
  recordCount: number;
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/scan/unreviewed',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindScansUnreviewed = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useFindScansUnreviewedLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindScansUnreviewed;
